import { api, success } from "@";

// Fetch all pages with default pagination
export const getPages = () =>
  api.post(`/api/AdminWebsitePages/all`, {
    page: 1,
    pageSize: null,
  });

// Toggle the active status of a page by ID
export const toggleActive = (id, value) =>
  api.put(`/api/AdminWebsitePages/change-status/${id}?status=${value}`);

// Save a new page
export const savePage = (data) => api.post("/api/AdminWebsitePages/add", data);

// Fetch a page by ID
export const getPage = (id) => api.get(`/api/AdminWebsitePages/${id}`);

// Update an existing page by ID
export const updatePage = async (data, id) => {
  try {
    await api.put(`/api/AdminWebsitePages/update/${id}`, data);
    success("تم التعديل بنجاح");
  } catch (error) {}
};

// Get or save the privacy policy
export const getSavePrivacyPolicy = (data) => {
  if (data) {
    return api.post(`/api/AdminWebsitePages/privacy-policy`, data);
  }
  return api.get(`/api/AdminWebsitePages/privacy-policy`);
};

// Get or save the terms and conditions
export const getSaveTermsConditions = (data) => {
  if (data) {
    return api.post(`/api/AdminWebsitePages/terms-and-conditions`, data);
  }
  return api.get(`/api/AdminWebsitePages/terms-and-conditions`);
};
